<div class="dropdown">
    <!-- Trigger button with custom icon (update the image source as needed) -->
    <button 
      class="btn btn-outline-secondary dropdown-toggle p-0 m-0 border-0" 
      type="button" 
      id="infoMenuDropdown" 
      data-bs-toggle="dropdown" 
      aria-expanded="false"
    >
      <img 
        src="assets/images/icon_help.png" 
        alt="Info Menu Icon" 
        class="info-menu-icon"
      />
    </button>
  
    <!-- Dropdown menu -->
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="infoMenuDropdown">
        <a class="dropdown-item" href="https://swirlaiconnect.com/support-ticket" target="_blank">
          Support Form
        </a>
      <li>
        <a class="dropdown-item" href="https://swirlaiconnect.com/faq/" target="_blank">
          Support Resources
        </a>
      </li>
      <li class="dropdown-divider"></li>
      <li class="swirl-version dropdown-item">
        Version: {{ swirlVersion }}
      </li>
    </ul>
  </div>
  